import { z } from 'zod'
import { LanguageValidation } from '../../../../../shared/domain/Language'

export const GETThemesQuery = z.object({
  language: LanguageValidation.shape.value,
})

export type GETThemesResponseType = z.infer<typeof GETThemesResponse>
export const GETThemesResponse = z.object({
  themes: z
    .object({
      name: z.string(),
      slug: z.string(),
    })
    .array(),
})
